const audience = [
  { icon: "ri-building-2-line", label: "Title agency owners" },
  { icon: "ri-briefcase-4-line", label: "Sales leaders" },
  { icon: "ri-team-line", label: "Business development teams" },
  { icon: "ri-line-chart-line", label: "Growth-focused operations leaders" },
  { icon: "ri-global-line", label: "Regional and enterprise title groups" },
];

const notFor = [
  "Real estate agents",
  "Mortgage lenders (not a fit yet)",
  "Teams happy with their current closings volume",
];

export default function WebinarAudienceSection() {
  return (
    <section className="bg-white py-14 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 bg-alt-bg border border-gray-200 rounded-full px-4 py-1.5 mb-6">
              <i className="ri-user-heart-line text-navy text-xs" />
              <span className="text-xs font-semibold text-navy">Who Should Attend</span>
            </div>

            <h2
              className="text-navy font-bold mb-5"
              style={{ fontSize: "clamp(26px, 3vw, 38px)", lineHeight: "1.2" }}
            >
              Built for Title Leaders Who Want to Grow
            </h2>

            <p className="text-[#4a5568] text-base leading-relaxed mb-6 md:mb-8" style={{ lineHeight: "1.65" }}>
              This webinar is designed for title decision-makers who want more scale, better timing, and a stronger system for winning the next closing.
            </p>

            <ul className="flex flex-col gap-4">
              {audience.map((item) => (
                <li key={item.label} className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary text-base`} />
                  </div>
                  <span className="text-navy font-semibold text-sm">{item.label}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: "Not for" + urgency card */}
          <div className="flex flex-col gap-6">
            {/* Urgency card */}
            <div className="rounded-2xl bg-navy text-white px-5 md:px-8 py-5 md:py-7">
              <div className="flex items-center gap-3 mb-4">
                <span className="w-9 h-9 flex items-center justify-center bg-primary/20 rounded-xl">
                  <i className="ri-alarm-warning-line text-primary text-base" />
                </span>
                <h3 className="text-white font-bold text-base">Why Attend Live?</h3>
              </div>
              <ul className="flex flex-col gap-3">
                {[
                  "Live Q&A — ask about your specific market",
                  "See real AI calls played during the session",
                  "Understand the exact break-even model for your team",
                  "Limited live seats — replay access not guaranteed",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-primary text-sm" />
                    </span>
                    <span className="text-white/80 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => document.getElementById("webinar-form")?.scrollIntoView({ behavior: "smooth", block: "center" })}
                className="mt-6 w-full bg-primary hover:bg-orange-600 text-white font-semibold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                Secure My Spot
              </button>
            </div>

            {/* Not for section */}
            <div className="rounded-2xl bg-alt-bg border border-gray-200 px-5 md:px-7 py-5 md:py-6">
              <h4 className="text-navy font-bold text-sm mb-4">This Webinar Is NOT For:</h4>
              <ul className="flex flex-col gap-2.5">
                {notFor.map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                      <i className="ri-close-circle-line text-red-400 text-sm" />
                    </span>
                    <span className="text-[#4a5568] text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
